
import { mapGetters, mapState } from "vuex";
import {
  toActiveTabId,
  toBreadcrumb,
  toHeaderContext,
  toTabOptions,
} from "~/transformers/AgencyHeaderTransformer";

export default {
  name: "AgencyPageHeader",
  computed: {
    ...mapState("application", ["selectedAgency", "selectedInstance"]),
    ...mapGetters({
      isSingleAgencyUser: "application/isSingleAgencyUser",
      isInAgency: "application/isInAgency",
      isInFederatedInstance: "application/isInFederatedInstance",
    }),
    /** Mirrors `isSecondaryNavVisible` from the old layout pill. */
    isVisible() {
      const routeName = this.$route.name ?? "";
      if (this.isSingleAgencyUser) {
        return routeName.includes("agencies-agency");
      }
      if (this.isInFederatedInstance) {
        return routeName.includes("federated-instanceId-agencyId");
      }
      return this.isInAgency && routeName.includes("agencies-agency");
    },
    headerContext() {
      if (!this.isVisible) return null;
      return toHeaderContext({
        isFederated: this.isInFederatedInstance,
        selectedAgency: this.selectedAgency,
        selectedInstance: this.selectedInstance,
      });
    },
    breadcrumb() {
      return this.headerContext ? toBreadcrumb(this.headerContext, this.$t.bind(this)) : [];
    },
    tabOptions() {
      return this.headerContext ? toTabOptions(this.headerContext, this.$t.bind(this)) : [];
    },
    activeTabId() {
      return toActiveTabId(
        this.tabOptions.map((tab) => tab.id),
        this.$route.path,
      );
    },
    lastUpdate() {
      const updatedOn = this.isInFederatedInstance
        ? this.selectedInstance?.updatedOn
        : this.selectedAgency?.updatedOn;
      return updatedOn ? updatedOn * 1000 : null;
    },
  },
  methods: {
    onTabChange(id) {
      if (this.$route.path !== id) this.$router.push(id);
    },
  },
};
